// extracted by mini-css-extract-plugin
module.exports = {"csr-G":"G_csr-G__RqCRx"};